import { BaseComponent } from "react-vextensions";
import { Row } from "react-vcomponents";
export class PanelHeader extends BaseComponent {
    render() {
        let { text, children } = this.props;
        return (React.createElement(Row, { style: { textAlign: "center", background: "hsla(0,0%,10%,.7)" } },
            React.createElement(Row, { p: 5, style: { fontSize: 16 } }, text),
            children &&
                React.createElement(Row, { ml: "auto", mr: 5 }, children)));
    }
}
